import { render, staticRenderFns } from "./pPIS.vue?vue&type=template&id=b2e2c282"
import script from "./pPIS.vue?vue&type=script&lang=js"
export * from "./pPIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports